import { TPAComponentProps } from '../../types';
import { CardProps } from '../Card';

export enum LegacyCardRatioOptions {
  RATIO_100 = '100',
  RATIO_50_50 = '50',
  RATIO_40_60 = '40',
  RATIO_30_70 = '30',
}

export interface LegacyCardProps extends TPAComponentProps, CardProps {
  media?: React.ReactNode;
  info?: React.ReactNode;
  ratio?: LegacyCardRatioOptions;
  flippedRatio?: boolean;
  /** puts the media slot on the opposite of the info slot. disabled on mobile */
  invertInfoPosition?: boolean;
  stacked?: boolean;
  /** puts the media slot on top of the info slot. disables the `ratio` behavior */
  mediaAspectRatio?: number;
}
